import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class DateManagerService {
  constructor() {}
  private datesFormater = date => new Date(date);
  public datesFormaterByDay = date => {
    date = this.datesFormater(date);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  public datesFomraterByMonth = (date: Date) => {
    date = this.datesFormater(date);
    return `${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  public datesFormaterByYear = (date: Date) => {
    date = this.datesFormater(date);
    return `${date.getFullYear()}`;
  };
}
